// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .fb-bg-primary[data-v-03154ad8] {\n  background-color: rgb(var(--vs-primary)) !important;\n}", ""]);
// Exports
module.exports = exports;
